export default "__VITE_ASSET__I$iKLDdf__"